
import GpsSlash from "../../../assets/duotone/GpsSlash.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function GpsSlashIcon({ className, dataTestid = "GpsSlashIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <GpsSlash data-testid={dataTestid} className={classes} {...rest} />
  );
}
